import React from "react";
import "./Footer.css";
import Github from "../../assets/Github.png";
import LinkedIn from "../../assets/linkedin.png";
import Insta from "../../assets/insta.png";
import Logo from "../../assets/logo.png";

const Footer = () => {
  return (
    <div className="Footer-c">
      <hr />
      <div className="footer">
        <div className="social">
          <img src={Github} alt="" />
          <img src={LinkedIn} alt="" />
          <img src={Insta} alt="" />
        </div>
        <div className="logo-f">
          <img src={Logo} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Footer;
